/**
 * Returns a human-readable relative time string for the given ISO timestamp.
 * Uses Intl.RelativeTimeFormat — no external library required.
 */
export function relativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  const now = Date.now();
  const diff = (then - now) / 1000; // seconds (negative = past)
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const abs = Math.abs(diff);
  if (abs < 60) return rtf.format(Math.round(diff), 'second');
  if (abs < 3600) return rtf.format(Math.round(diff / 60), 'minute');
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), 'hour');
  if (abs < 604800) return rtf.format(Math.round(diff / 86400), 'day');
  if (abs < 2419200) return rtf.format(Math.round(diff / 604800), 'week');
  return rtf.format(Math.round(diff / 2419200), 'month');
}
